var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload-file',{staticClass:"w-full m-2",attrs:{"btnType":"line","btnColor":"success","btnText":_vm._f("capitalize")(_vm.$t(_vm.text)),"accept":".xlsx","disabled":_vm.disabled},on:{"input":_vm.upload},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }